import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { XolaBotEarningsReportFilter } from "../../components/Reports/XolaBotEarningsReport/XolaBotEarningsReportFilter";
import { XolaBotEarningsReportSummary } from "../../components/Reports/XolaBotEarningsReport/XolaBotEarningsReportSummary";
import { XolaBotEarningsReportTransactions } from "../../components/Reports/XolaBotEarningsReport/XolaBotEarningsReportTransactions";
import { Page } from "../Page";

export const XolaBotEarningsReportPage = () => {
    const history = useHistory();

    const handleClick = () => {
        history.push("/reports/xolabotEarningsReport");
    };

    return (
        <Page title="Earnings Report">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Xolabot Earnings Report</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <div>
                    <XolaBotEarningsReportFilter />
                    <XolaBotEarningsReportSummary />
                    <XolaBotEarningsReportTransactions />
                </div>
            </ColumnLayout>
        </Page>
    );
};
